var context = require.context("./views/mixins", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});

var context = require.context("./views", true, /\.js$/);
context.keys().forEach( function(key) {
  context(key);
});
